import { render, staticRenderFns } from "./NewImageEditor.vue?vue&type=template&id=435b21fb&scoped=true&"
import script from "./NewImageEditor.vue?vue&type=script&lang=js&"
export * from "./NewImageEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewImageEditor.vue?vue&type=style&index=0&id=435b21fb&lang=scss&scoped=true&"
import style1 from "./NewImageEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b21fb",
  null
  
)

export default component.exports